<template>
  <svg xmlns="http://www.w3.org/2000/svg" id="Camada_2" viewBox="0 0 34.95 30.17">
    <g id="Camada_1-2" data-name="Camada_1">
      <g>
        <path
          d="M11.64,12.89c1.45,1.55,2.94,3.14,4.41,4.71.44.47,1.15.47,1.59,0,3.78-4.03,6.55-6.99,10.32-11.01l-.66-.78c-.14-.17-.22-.38-.22-.6h0c0-.5.38-.9.85-.9h2.59c.35,0,.64.31.64.68v2.8c0,.47-.36.85-.8.85h0c-.22,0-.44-.1-.59-.27l-.75-.86c-4.16,4.46-7.21,7.72-11.26,12.04-.44.47-1.15.47-1.59,0-1.57-1.68-3.1-3.31-4.64-4.96-.29-.3-.75-.3-1.03,0-1.92,2.07-3.83,4.12-5.78,6.21-.22.24-.58.22-.78-.03h0c-.18-.24-.17-.57.03-.77,1.2-1.28,5.23-5.57,6.66-7.1.28-.3.74-.3,1.03,0Z" />
        <path
          d="M2.06,23.76V0h-1.06C.45,0,0,.45,0,1.01v24.74c0,2.45,1.98,4.43,4.43,4.43h29.52c.56,0,1.01-.45,1.01-1.01h0c0-.56-.45-1.01-1.01-1.01l-27.45.03c-2.45,0-4.43-1.98-4.43-4.43Z" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ReportIcon'
}
</script>
